// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
console.log('🚀 application.js cargado');

import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import "channels"

Rails.start()
Turbolinks.start()
ActiveStorage.start()

import "controllers"
import "bootstrap"
import "../src/add-eu-banner"

require("trix")
require("@rails/actiontext")

// ——— Pixel tracking para WhatsApp ———
function trackWhatsappClick() {
  if (window.fbq) {
    fbq('trackCustom', 'WhatsappClick');
  }
}

document.addEventListener('turbolinks:load', () => {
  const btn = document.getElementById('whatsapp-link');
  if (btn) {
    btn.addEventListener('click', trackWhatsappClick);
  }
});
document.addEventListener('turbolinks:load', () => {
  const btn = document.getElementById('whatsapp-link-show-1');
  if (btn) {
    btn.addEventListener('click', () => {
      if (window.fbq) fbq('trackCustom', 'WhatsappClick');
    });
  }
});
document.addEventListener('turbolinks:load', () => {
  const btn = document.getElementById('whatsapp-link-show-2');
  if (btn) {
    btn.addEventListener('click', () => {
      if (window.fbq) fbq('trackCustom', 'WhatsappClick');
    });
  }
});

// ——— Solo Google Ads tracking para WhatsApp ———
function trackWhatsappGAdsClick(e) {
  // 1) Evitamos que el navegador abra el enlace inmediatamente
  e.preventDefault()

  // 2) Capturamos la URL del enlace
  const url = e.currentTarget.href


  // 3) Si tu helper gtagSendEvent está disponible, lo usamos
  if (window.gtagSendEvent) {
    gtagSendEvent(url)
  } else {
    // 4) Fallback: si gtag no carga, al menos abrimos el chat
    window.open(url, '_blank')
  }
}

document.addEventListener('turbolinks:load', () => {
  // 5) Volvemos a seleccionar los mismos tres IDs
  ['whatsapp-link', 'whatsapp-link-show-1', 'whatsapp-link-show-2']
    .forEach(id => {
      const btn = document.getElementById(id)
      if (!btn) return

      // 6) Y les agregamos el listener de Google Ads
      btn.addEventListener('click', trackWhatsappGAdsClick)
    })
})
// ——— Fin Google Ads tracking para WhatsApp ———

// ——— Bing Ads tracking para WhatsApp ———
function trackWhatsappBingClick() {
  if (typeof uet_report_conversion === 'function') {
    uet_report_conversion();
  }
}

document.addEventListener('turbolinks:load', () => {
  ['whatsapp-link', 'whatsapp-link-show-1', 'whatsapp-link-show-2']
    .forEach(id => {
      const btn = document.getElementById(id);
      if (!btn) return;
      btn.addEventListener('click', trackWhatsappBingClick);
    });
});
// ——— Fin Bing Ads tracking para WhatsApp ———
